import { PageGetterType } from './types';

import Cover from './Cover';
import Author from './Author';
import About from './About';
import Summary from './Summary';
import Part1 from './Part1';
import Part1P1 from './Part1/P1';
import Part1P2 from './Part1/P2';
import Part1P3 from './Part1/P3';
import Part1P4 from './Part1/P4';
import Part2 from './Part2';
import Part2P1 from './Part2/P1';
import Part2P2 from './Part2/P2';
import Part2P3 from './Part2/P3';
import Part2P4 from './Part2/P4';
import Part2P5 from './Part2/P5';
import Part2P6 from './Part2/P6';
import Part3 from './Part3';
import Part3P1 from './Part3/P1';
import Part3P2 from './Part3/P2';
import Part3P3 from './Part3/P3';
import Part4 from './Part4';
import Part4P1 from './Part4/P1';
import Part4P2 from './Part4/P2';
import Part4P3 from './Part4/P3';
import Part4P4 from './Part4/P4';
import Part5 from './Part5';
import Part5P1 from './Part5/P1';
import Part5P2 from './Part5/P2';
import Part5P3 from './Part5/P3';
import Part5P4 from './Part5/P4';
import Part5P5 from './Part5/P5';
import Part5P6 from './Part5/P6';
import Part5P7 from './Part5/P7';
import Part5P8 from './Part5/P8';
import Part5P9 from './Part5/P9';
import Part6 from './Part6';
import Part6P1 from './Part6/P1';
import Part6P2 from './Part6/P2';
import Part6P3 from './Part6/P3';
import Part6P4 from './Part6/P4';
import Part6P5 from './Part6/P5';
import Part6P6 from './Part6/P6';
import Part7 from './Part7';
import Part7P1 from './Part7/P1';
import Part7P2 from './Part7/P2';
import Part7P3 from './Part7/P3';
import Part7P4 from './Part7/P4';
import Part8 from './Part8';
import Part8P1 from './Part8/P1';
import Part8P2 from './Part8/P2';
import Part8P3 from './Part8/P3';
import Part8P4 from './Part8/P4';
import Part9 from './Part9';
import Part9P1 from './Part9/P1';
import Part9P2 from './Part9/P2';
import Part9P3 from './Part9/P3';
import Part10 from './Part10';
import Part10P1 from './Part10/P1';
import Thanks from './Thanks';

export const getPage: PageGetterType = function (props) {
  const { pageIndex, pageSetter } = props;

  if (pageIndex === 0) return <Cover />;
  if (pageIndex === 1) return <Author />;
  if (pageIndex === 2) return <About />;
  if (pageIndex === 3) return <Summary pageSetter={pageSetter} />;
  if (pageIndex === 4) return <Part1 />;
  if (pageIndex === 5) return <Part1P1 />;
  if (pageIndex === 6) return <Part1P2 />;
  if (pageIndex === 7) return <Part1P3 />;
  if (pageIndex === 8) return <Part1P4 />;
  if (pageIndex === 9) return <Part2 />;
  if (pageIndex === 10) return <Part2P1 />;
  if (pageIndex === 11) return <Part2P2 />;
  if (pageIndex === 12) return <Part2P3 />;
  if (pageIndex === 13) return <Part2P4 />;
  if (pageIndex === 14) return <Part2P5 />;
  if (pageIndex === 15) return <Part2P6 />;
  if (pageIndex === 16) return <Part3 />;
  if (pageIndex === 17) return <Part3P1 />;
  if (pageIndex === 18) return <Part3P2 />;
  if (pageIndex === 19) return <Part3P3 />;
  if (pageIndex === 20) return <Part4 />;
  if (pageIndex === 21) return <Part4P1 />;
  if (pageIndex === 22) return <Part4P2 />;
  if (pageIndex === 23) return <Part4P3 />;
  if (pageIndex === 24) return <Part4P4 />;
  if (pageIndex === 25) return <Part5 />;
  if (pageIndex === 26) return <Part5P1 />;
  if (pageIndex === 27) return <Part5P2 />;
  if (pageIndex === 28) return <Part5P3 />;
  if (pageIndex === 29) return <Part5P4 />;
  if (pageIndex === 30) return <Part5P5 />;
  if (pageIndex === 31) return <Part5P6 />;
  if (pageIndex === 32) return <Part5P7 />;
  if (pageIndex === 33) return <Part5P8 />;
  if (pageIndex === 34) return <Part5P9 />;
  if (pageIndex === 35) return <Part6 />;
  if (pageIndex === 36) return <Part6P1 />;
  if (pageIndex === 37) return <Part6P2 />;
  if (pageIndex === 38) return <Part6P3 />;
  if (pageIndex === 39) return <Part6P4 />;
  if (pageIndex === 40) return <Part6P5 />;
  if (pageIndex === 41) return <Part6P6 />;
  if (pageIndex === 42) return <Part7 />;
  if (pageIndex === 43) return <Part7P1 />;
  if (pageIndex === 44) return <Part7P2 />;
  if (pageIndex === 45) return <Part7P3 />;
  if (pageIndex === 46) return <Part7P4 />;
  if (pageIndex === 47) return <Part8 />;
  if (pageIndex === 48) return <Part8P1 />;
  if (pageIndex === 49) return <Part8P2 />;
  if (pageIndex === 50) return <Part8P3 />;
  if (pageIndex === 51) return <Part8P4 />;
  if (pageIndex === 52) return <Part9 />;
  if (pageIndex === 53) return <Part9P1 />;
  if (pageIndex === 54) return <Part9P2 />;
  if (pageIndex === 55) return <Part9P3 />;
  if (pageIndex === 56) return <Part10 />;
  if (pageIndex === 57) return <Part10P1 />;
  if (pageIndex === 58) return <Thanks />;

  return <div></div>;
};

export const pagesLength = 59;
